import { useController } from '@framework/form/hooks/useController.ts';
import { Button, message } from 'antd';
import { Map, View } from 'ol';
import TileLayer from 'ol/layer/Tile';
import { OSM } from 'ol/source';
import * as React from 'react';
import { OpenLayersMap } from '../../../../maps/OpenLayerMap.tsx';

export interface IMapExtentInputProps {
  name: string;
}
/**
 * Permette di indicare centro e zoom della mappa.
 */
export function MapExtentInput(props: IMapExtentInputProps) {
  const {
    field: { onChange: centerOnChange, value: centerValue },
  } = useController(`${props.name}.center`);
  const {
    field: { onChange: zoomOnChange, value: zoomValue },
  } = useController(`${props.name}.zoom`);

  const mapRef = React.useRef<Map | null>(null);

  const initMap = React.useCallback((element: HTMLDivElement) => {
    console.log(`[MapExtentInput] initMap`, centerValue, zoomValue);
    const map = new Map({
      target: element,
      layers: [
        new TileLayer({
          source: new OSM(),
        }),
      ],
      view: new View({
        center: centerValue ?? [11.189_417_912_530_622, 44.576_276_442_981_985],
        zoom: zoomValue ?? 4,
      }),
    });

    mapRef.current = map;
    return map;
  }, []);

  return (
    <div>
      <OpenLayersMap
        init={initMap}
        controls={
          <div style={{ position: 'absolute', top: '10px', right: '10px' }}>
            <Button
              onClick={e => {
                const view = mapRef.current!.getView();
                centerOnChange(view.getCenter() as number[]);
                zoomOnChange(view.getZoom()!);
                message.success('Centro e zoom selezionati');
                e.preventDefault();
                e.stopPropagation();
              }}
            >
              Seleziona centro e zoom
            </Button>
          </div>
        }
        style={{ height: '200px' }}
      />
    </div>
  );
}
